import { ResourceModel } from "generated/CoreApi_v1";

export default class ResourceUtils {

    /**
     * Encontra o texto correspondente ao locale informado, ou ao locale parcial, ou ao locale padrão.
     * @param data Array de ResourceModel
     * @param locale Locale desejado
     * @param defaultLocale Locale padrão
     * @returns Texto correspondente ao locale
     */
    static findName(data: ResourceModel[], locale: string, defaultLocale: string) {
        return data.find(p => p.locale == locale)?.text
            ?? data.find(p => p.locale == locale.substr(0, 2))?.text
            ?? data.find(p => p.locale == defaultLocale)?.text;
    }

    /**
     * Cria uma coleção de LocaleInputCollection vazia para os locales informados.
     * @param locales Array de locales
     * @returns Coleção de objetos com locale e texto nulo
     */
    static buildEmptyLocaleInputCollection(locales: string[]): LocaleInputCollection {
        return locales.map((v) => ({ locale: v, text: null }));
    }

    /**
     * Verifica se o array de recursos está vazio ou se o texto do locale padrão está vazio.
     * @param data Array de ResourceModel
     * @param defaultLocale Locale padrão
     * @returns Verdadeiro se estiver vazio
     */
    static isEmpty(data: ResourceModel[], defaultLocale: string) {
        return data == undefined || data.length == 0 || (data.find(p => p.locale == defaultLocale)?.text ?? "").length == 0;
    }
}
